import { Resume, SingleTemplateConfigSettings } from '@rio/types'
import { useI18n } from 'builder/hooks/useI18n'

import { SlideInput } from '../../SlideInput/SlideInput'
import { useGetFontSize } from '../hooks/useGetFontSize'
import { FontSizeFieldIds } from '../types'
import { TEXT_TAB_TRANSLATION } from '../constants'

import { OldFontSize } from './OldFontSize'
import * as Styles from './styles'

type Props = {
  resume: Resume
  currentTemplate: SingleTemplateConfigSettings
}

type Input = {
  key: FontSizeFieldIds
  data: ReturnType<typeof useGetFontSize>['primaryFontSize']
}

export const FontSize = (props: Props) => {
  const { resume, currentTemplate } = props
  const isCustomizationEnabled = currentTemplate?.supportsFontSizesCustomization

  const { i18n } = useI18n()
  const {
    primaryFontSize,
    secondaryFontSize,
    bodyFontSize,
    sectionTitleFontSize,
    getFontSizeLabel,
    handleSettingsFieldChange,
  } = useGetFontSize({ resume: resume })

  const inputs: Input[] = [
    { key: 'fontSizePrimaryHeading', data: primaryFontSize },
    { key: 'fontSizeSecondaryHeading', data: secondaryFontSize },
    { key: 'fontSizeBody', data: bodyFontSize },
    { key: 'fontSizeSectionTitles', data: sectionTitleFontSize },
  ]

  if (!isCustomizationEnabled) {
    return <OldFontSize resume={resume} handleSettingsFieldChange={handleSettingsFieldChange} />
  }

  return (
    <Styles.Container>
      <Styles.Header>{i18n.t(`${TEXT_TAB_TRANSLATION}.font_size.title`)}</Styles.Header>
      {inputs.map(input => (
        <SlideInput
          key={input.key}
          unit="pt"
          disabled={false}
          name={getFontSizeLabel(input.key)}
          value={input.data.value}
          defaultValue={input.data.defaultValue}
          onChange={input.data.onChange}
          min={input.data.min}
          max={input.data.max}
          step={input.data.step}
        />
      ))}
    </Styles.Container>
  )
}
